import { SidebarHeader } from "@/components/sidebar/components/SidebarHeader.tsx";
import usePermissions from "@/hooks/use-permissions.hook.ts";
import { useDocumentFoldersList } from "@/queries/use-documents.query.ts";
import { ApiFolderType, folderParamKeys } from "@/types/document.types.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";
import { Box, FontAwesomeIcon, SidebarPanelItem, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";

export const SidebarDocs = () => {
  const { t } = useTranslation();
  const { canIEdit, isFeatureEnabled } = usePermissions();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();

  const folderParamKey = folderParamKeys[ApiFolderType.organization];
  const selectedFolderId = searchParams.get(folderParamKey);

  const { data: folders } = useDocumentFoldersList(ApiFolderType.organization);

  const canManageFolders = canIEdit(ApiPermission.settings_document_folders);

  return (
    <>
      <SidebarHeader title={t("core:documents")} />
      <Stack className={"px-4 pb-6"}>
        <Stack gap={"xs"}>
          <SidebarPanelItem
            to={"/docs"}
            isActive={pathname === "/docs" && !selectedFolderId}
            title={t("core:all_docs")}
            icon={<FontAwesomeIcon icon={"fa-light fa-folder"} />}
          />
          {isFeatureEnabled(ApiFeatureType.esign) && canIEdit(ApiPermission.esign_request) && (
            <SidebarPanelItem
              to={"/docs/esign-requests"}
              isActive={pathname === "/docs/esign-requests"}
              title={t("core:esign_requests")}
              icon={<FontAwesomeIcon icon={"fa-light fa-signature"} />}
            />
          )}
        </Stack>

        {folders && folders.length > 0 && (
          <>
            <Box className={"px-2"}>
              <Title header={t("common:folders")} size={"xs"} paddingBottom paddingTop />
            </Box>
            <Stack gap={"xs"}>
              {folders.map((folder) => (
                <SidebarPanelItem
                  key={`docs-folder-${folder.id}`}
                  to={`/docs?${folderParamKey}=${folder.id}`}
                  isActive={selectedFolderId === String(folder.id)}
                  title={folder.title}
                />
              ))}
            </Stack>
          </>
        )}

        {canManageFolders && (
          <Stack gap={"xs"} className={"pt-4"}>
            <SidebarPanelItem
              to={"/docs/settings"}
              isActive={pathname.startsWith("/docs/settings")}
              title={t("common:manage_folders")}
              icon={<FontAwesomeIcon icon={"fa-gear"} className={"fa-light text-[14px]"} />}
            />
          </Stack>
        )}
      </Stack>
    </>
  );
};
